import React, { useEffect, useState } from 'react';
import './TopProgressBar.css';

const TopProgressBar = ({ isLoading = false, duration = 800 }) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setIsVisible(true);
      setProgress(0);

      // Simulate progress with easing
      const startTime = Date.now();
      const timer = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const progressPercent = Math.min((elapsed / duration) * 90, 90); // Max 90% until complete
        setProgress(progressPercent);

        if (progressPercent >= 90) {
          clearInterval(timer);
        }
      }, 16); // ~60fps

      return () => clearInterval(timer);
    } else if (progress > 0) {
      // Complete the progress bar
      setProgress(100);
      setTimeout(() => {
        setIsVisible(false);
        setProgress(0);
      }, 400);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, duration]);

  if (!isVisible) return null;

  return (
    <div className="top-progress-bar-container">
      <div
        className="top-progress-bar"
        style={{
          width: `${progress}%`,
          transition: progress === 100 ? 'width 0.4s ease-out' : 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      />
      <div className="top-progress-glow" style={{ width: `${progress}%` }} />
    </div>
  );
};

export default TopProgressBar;
